module.exports = __webpack_public_path__ + "img/2012300152177864819(1).65b03abf.png";